import type { EventDeliverableRow, EventDeliverable } from '../types/deliverable.types';

export function mapDbRowToEventDeliverable(row: EventDeliverableRow): EventDeliverable {
  return {
    id: row.id,
    event_id: row.event_id,
    influencer_name: row.influencer_name,
    platform: row.platform,
    expected_deliverable: row.expected_deliverable,
    deadline: row.deadline || '',
    status: row.status || 'pending',
    content_url: row.content_url || '',
    notes: row.notes || '',
    organization_id: row.organization_id,
    created_at: row.created_at || new Date().toISOString(),
    updated_at: row.updated_at || new Date().toISOString(),
  };
}
